module.exports = __webpack_public_path__ + "static/img/ph-icon.a5f28507.png";